var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #898989;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u6587\\u5B57",
    "data-name": "\\u6587\\u5B57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.99,0c3.29,0,6.27.94,8.42,2.46,2.21,1.57,3.59,3.76,3.59,6.16s-1.38,4.61-3.59,6.16c-2.15,1.55-5.14,2.49-8.42,2.49-.55,0-1.13-.03-1.71-.11-.5-.03-.99-.11-1.46-.19l-5.69,3.29c-.14.06-.3.08-.44.06-.3-.08-.5-.41-.41-.72l1.35-4.78c-1.05-.75-1.93-1.63-2.57-2.62C.39,11.07,0,9.89,0,8.62c0-2.4,1.38-4.58,3.59-6.16C5.74.94,8.73,0,11.99,0h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.03,
    cy: 8.62,
    r: 1.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 8.62,
    r: 1.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.97,
    cy: 8.62,
    r: 1.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech_bubble.65b58613ca775eba4f3fd350e9f5173a.svg";
export { ForwardRef as ReactComponent };